export const config = {
  /** サーバーサイド（SSR）から API にアクセスする URL */
  apiUrl: "http://localhost:3000",
  /** クライアントサイド（ブラウザ）から API にアクセスする URL */
  publicApiUrl: "http://localhost:3000",
  /** 公開サイトの URL（canonical URL 等に使用） */
  siteUrl: "http://e2e-test.localhost:3002",
  /** 管理画面の URL（preview バナーのリンク等に使用） */
  adminUrl: "http://localhost:3001",
} as const;
